export default __webpack_public_path__ + "static/media/fire-station-icon.92736149.svg";